module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Kick-a93d51366fb721efbbf73430d39d362e.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Kick.mp3
// module id = 51
// module chunks = 0